import React from 'react';
import { getVideoId } from '../../shared/getVideoId';
import './EmbeddedVideo.scss';

export const EmbeddedVideo = ({ node, forceInline }) => {
    const videoTitle = node.relationships?.field_video?.name;
    const id = getVideoId(
        node.relationships?.field_video?.field_media_oembed_video
    );
    return (
        <figure
            className={`embedded-video themed-container ${
                node.field_theme ? node.field_theme : ``
            }`}
        >
            <div className={`${forceInline ? `inline` : `kite-container`}`}>
                <div className="video">
                    <iframe
                        src={`https://player.vimeo.com/video/${id}?=color=0099d8&title=0&byline=0&portrait=0`}
                        width="100%"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        title={videoTitle}
                    ></iframe>
                </div>
                {node.field_subtitle && (
                    <figcaption>{node.field_subtitle}</figcaption>
                )}
            </div>
        </figure>
    );
};
